import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DynamicImage = () => {
  const location = useLocation();
  const slug = location.pathname.replace("/", ""); // örnek: 'yenimahalle-hali-yikama'

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imagePath = isMobile
    ? `/${slug}-mobile.webp`
    : `/${slug}-desktop.png`; // 📂 public klasöründe iki resim olacak

  return (
     <div
      className="w-full mx-auto relative overflow-hidden"
      style={{ aspectRatio: isMobile ? "4 / 7" : "2 / 1" }}
    >
      <img
        src={imagePath}
        alt={slug}
        style={{ maxWidth: "100%", height: "auto" }}
        onError={(e) => (e.currentTarget.style.display = "none")}
      />
    </div>
  );
};

export default DynamicImage;
